// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { faqsService } from './service';
import * as faqsActions from './actions';
import * as types from './actionTypes';

function* faqsSaga() {
  const res = yield call(faqsService);
  if (res.ok) {
    const result = res.body.items[0];
    const { title } = result;
    let { questions } = result;
    questions = questions.map((el) => {
      return {
        title: el.title,
        text: el.text.substring(3, el.text.length - 4),
      };
    });

    yield put(faqsActions.requestPageDataSuccess({
      title,
      questions,
    }));
  }
}

const faqsSagas = [
  takeEvery(types.FAQS_REQUEST_PAGE_DATA, faqsSaga),
];

export default faqsSagas;
